import * as React from 'react';
import { connect } from 'react-redux';
import DispatchProps, { mapDispatchToProps } from '../application/core/DispatchProps';
import ResetPasswordConfirmed from '../application/estimations/events/ResetPasswordConfirmed';

interface Props {
    customerId: string;
}

class ResetPassword extends React.PureComponent<Props & DispatchProps> {
    public render(): JSX.Element {
        return (
            <>
                <div className="popup-title">Reset password</div>
                <div className="popup-text">Are you sure to reset password for this customer?.</div>
                <button onClick={this.confirmed}>yes</button>
            </>
        );
    }

    private confirmed = (): void => {
        this.props.dispatch(new ResetPasswordConfirmed(this.props.customerId));
    };
}

export default connect(mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/view/ResetPassword.tsx